<template>
  <span
    class="relative rounded-full py-1 text-xs px-3"
    :class="metaClasses"
    role="status"
    aria-label="Status Label"
  >
    <span class="block truncate max-w-[120px]">
      <slot></slot>
    </span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  background: {
    type: String,
    default: 'red-1',
  },
  text: {
    type: String,
    default: 'white',
  },
})

const metaClasses = computed(() => {
  return `bg-${props.background}/50 text-${props.text}`
})
</script>
